<template>
	<div>
		<h2>
			Tag Editor
			<div class="float-right">
				<button @click="save" class="btn btn-primary" v-if="tag.tag_name">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved">
			<div class="alert alert-success mt-8">Tag saved</div>
		</div>

		<div class="form-group">
			<label for="tag-name">Tag Name</label>
			<input id="tag-name" name="tagname" class="form-control" v-model="tag.tag_name" :placeholder="$t('title')" required>
		</div>

    </div>
</template>

<script>
export default {
	components: {
	},
    data: function() {
        return {
        	tag: {
        		tag_id: null,
        		tag_name: '',
        	},
        	saved: false
        }
    },
    methods: {
    	save() {

        	const data = {
        		tag_name: this.tag.tag_name,
        		save: true
			}

			if(this.tag.tag_id) {
				data.tag_id = this.tag.tag_id;
			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/tags/tag`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					this.$router.push('/settings/tagmanager');
					/*
					this.tag = json.tag;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
					*/
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
    	},
    	getTag(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/tags/tag`, {
  				data: {
  					tag_id: id
  				}
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {

					this.tag = json.tag;

				}
			}).catch(error => {
				this.$log.error.call(this, error);
				this.$store.commit("hideBlockingSpinner");
				this.$log.error.call(this, error);
			});
    	},
    },
    computed: {

    },
    mounted() {

    	if(this.$route.params.tagid) {
    		this.getTag(this.$route.params.tagid);
    	} else {
    		this.$store.commit("hideBlockingSpinner");
    	}
    }
}
</script>
